import { RootState } from '~/store';

export const showSeriesDetailsSelector = (state: RootState): boolean => state.series.showDetails;
export const showSeriesRankingSelector = (state: RootState): boolean => state.series.showRanking;
export const seriesActiveBountyIdSelector = (state: RootState): string => state.series.activeBountyId;
